"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { HexColorPicker } from "react-colorful";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { converter, Oklch, Rgb, Hsl, formatHex, parse } from "culori";
import { validateHSL, validateRGB, validateHEX, validateOklch } from "@/lib/colours";
import { ToolData } from ".";
const rgbConverter = converter("rgb");
const hslConverter = converter("hsl");
const oklchConverter = converter("oklch");
function ColourConverter(t0) {
  const $ = _c(154);
  const {
    title,
    description
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      mode: "hsl",
      h: 0,
      s: 0,
      l: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [hsl, setHSL] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      mode: "rgb",
      r: 0,
      g: 0,
      b: 0
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [rgb, setRGB] = useState(t2);
  const [hex, setHEX] = useState("#000000");
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      mode: "oklch",
      l: 0,
      c: 0,
      h: 0
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [oklch, setOklch] = useState(t3);
  const [okLightnessError, setOKLightnessError] = useState(false);
  const [okChromaError, setOKChromaError] = useState(false);
  const [okHueError, setOKHueError] = useState(false);
  const [hueError, setHueError] = useState(false);
  const [saturationError, setSaturationError] = useState(false);
  const [lightnessError, setLightnessError] = useState(false);
  const [redError, setRedError] = useState(false);
  const [greenError, setGreenError] = useState(false);
  const [blueError, setBlueError] = useState(false);
  const [hexError, setHexError] = useState(false);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setOKLightnessError(false);
      setOKChromaError(false);
      setOKHueError(false);
      setHueError(false);
      setSaturationError(false);
      setLightnessError(false);
      setRedError(false);
      setGreenError(false);
      setBlueError(false);
      setHexError(false);
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const clearErrors = t4;
  let t5;
  if ($[4] !== title) {
    t5 = <CardTitle>{title}</CardTitle>;
    $[4] = title;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== description) {
    t6 = <CardDescription>{description}</CardDescription>;
    $[6] = description;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <CardHeader>{t5}{t6}</CardHeader>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = value => {
      setHEX(value);
      setRGB(rgbConverter(value) as Rgb);
      setHSL(hslConverter(value) as Hsl);
      setOklch(oklchConverter(value) as Oklch);
    };
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== hex) {
    t9 = <HexColorPicker className="flex-1" color={hex} onChange={t8} />;
    $[12] = hex;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== hex) {
    t10 = <div className="flex-1 rounded-lg" style={{
      backgroundColor: hex
    }} />;
    $[14] = hex;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t9) {
    t11 = <div className="flex flex-row gap-8">{t9}{t10}</div>;
    $[16] = t10;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <h2 className="leading-loose">Oklch</h2>;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Label htmlFor="oklch-l">Lightness</Label>;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  const t14 = isNaN(oklch.l) ? "" : oklch.l;
  let t15;
  if ($[21] !== oklch) {
    t15 = e => {
      const newOklch = {
        ...oklch,
        l: parseFloat(e.target.value)
      };
      setOklch(newOklch);
      if (validateOklch(newOklch)) {
        const newRgb = rgbConverter(newOklch);
        setHSL(hslConverter(newOklch));
        setRGB(newRgb);
        setHEX(formatHex(newRgb));
        clearErrors();
      } else {
        setOKLightnessError(true);
      }
    };
    $[21] = oklch;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = e_0 => {
      const pastedData = e_0.clipboardData.getData("text");
      const parsed = parse(pastedData);
      if (parsed && parsed.mode === "oklch") {
        e_0.preventDefault();
        setOklch(parsed);
        const newRgb_0 = rgbConverter(parsed);
        setHSL(hslConverter(parsed));
        setRGB(newRgb_0);
        setHEX(formatHex(newRgb_0));
        clearErrors();
      }
    };
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== t14 || $[25] !== t15) {
    t17 = <Input id="oklch-l" type="number" step={0.01} min={0} max={1} value={t14} onChange={t15} onPaste={t16} />;
    $[24] = t14;
    $[25] = t15;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  const t18 = okLightnessError ? "Must be between 0 and 1" : null;
  let t19;
  if ($[27] !== t18) {
    t19 = <div className="text-destructive h-5 text-sm">{t18}</div>;
    $[27] = t18;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== t17 || $[30] !== t19) {
    t20 = <div className="flex flex-1 flex-col gap-2">{t13}{t17}{t19}</div>;
    $[29] = t17;
    $[30] = t19;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Label htmlFor="oklch-c">Chroma</Label>;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  const t22 = isNaN(oklch.c) ? "" : oklch.c;
  let t23;
  if ($[33] !== oklch) {
    t23 = e_1 => {
      const newOklch_0 = {
        ...oklch,
        c: parseFloat(e_1.target.value)
      };
      setOklch(newOklch_0);
      if (validateOklch(newOklch_0)) {
        const newRgb_1 = rgbConverter(newOklch_0);
        setHSL(hslConverter(newOklch_0));
        setRGB(newRgb_1);
        setHEX(formatHex(newRgb_1));
        clearErrors();
      } else {
        setOKChromaError(true);
      }
    };
    $[33] = oklch;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] !== t22 || $[36] !== t23) {
    t24 = <Input id="oklch-c" type="number" value={t22} step={0.01} min={0} max={0.4} onChange={t23} />;
    $[35] = t22;
    $[36] = t23;
    $[37] = t24;
  } else {
    t24 = $[37];
  }
  const t25 = okChromaError ? "Must be between 0 and 0.4" : null;
  let t26;
  if ($[38] !== t25) {
    t26 = <div className="text-destructive h-5 text-sm">{t25}</div>;
    $[38] = t25;
    $[39] = t26;
  } else {
    t26 = $[39];
  }
  let t27;
  if ($[40] !== t24 || $[41] !== t26) {
    t27 = <div className="flex flex-1 flex-col gap-2">{t21}{t24}{t26}</div>;
    $[40] = t24;
    $[41] = t26;
    $[42] = t27;
  } else {
    t27 = $[42];
  }
  let t28;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <Label htmlFor="oklch-h">Hue</Label>;
    $[43] = t28;
  } else {
    t28 = $[43];
  }
  const t29 = !oklch.h || isNaN(oklch.h) ? "" : oklch.h;
  let t30;
  if ($[44] !== oklch) {
    t30 = e_2 => {
      const newOklch_1 = {
        ...oklch,
        h: parseFloat(e_2.target.value)
      };
      setOklch(newOklch_1);
      if (validateOklch(newOklch_1)) {
        const newRgb_2 = rgbConverter(newOklch_1);
        setHSL(hslConverter(newOklch_1));
        setRGB(newRgb_2);
        setHEX(formatHex(newRgb_2));
        clearErrors();
      } else {
        setOKHueError(true);
      }
    };
    $[44] = oklch;
    $[45] = t30;
  } else {
    t30 = $[45];
  }
  let t31;
  if ($[46] !== t29 || $[47] !== t30) {
    t31 = <Input id="oklch-h" type="number" value={t29} step={1} min={0} max={360} onChange={t30} />;
    $[46] = t29;
    $[47] = t30;
    $[48] = t31;
  } else {
    t31 = $[48];
  }
  const t32 = okHueError ? "Must be between 0 and 360" : null;
  let t33;
  if ($[49] !== t32) {
    t33 = <div className="text-destructive h-5 text-sm">{t32}</div>;
    $[49] = t32;
    $[50] = t33;
  } else {
    t33 = $[50];
  }
  let t34;
  if ($[51] !== t31 || $[52] !== t33) {
    t34 = <div className="flex flex-1 flex-col gap-2">{t28}{t31}{t33}</div>;
    $[51] = t31;
    $[52] = t33;
    $[53] = t34;
  } else {
    t34 = $[53];
  }
  let t35;
  if ($[54] !== t20 || $[55] !== t27 || $[56] !== t34) {
    t35 = <div>{t12}<div className="flex flex-col gap-3 md:flex-row">{t20}{t27}{t34}</div></div>;
    $[54] = t20;
    $[55] = t27;
    $[56] = t34;
    $[57] = t35;
  } else {
    t35 = $[57];
  }
  let t36;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <h2 className="leading-loose">HSL</h2>;
    $[58] = t36;
  } else {
    t36 = $[58];
  }
  let t37;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <Label htmlFor="hsl-h">Hue</Label>;
    $[59] = t37;
  } else {
    t37 = $[59];
  }
  const t38 = !hsl.h || isNaN(hsl.h) ? "" : hsl.h;
  let t39;
  if ($[60] !== hsl) {
    t39 = e_3 => {
      const newHSL = {
        ...hsl,
        h: parseFloat(e_3.target.value)
      };
      setHSL(newHSL);
      if (validateHSL(newHSL)) {
        const newRgb_3 = rgbConverter(newHSL);
        setOklch(oklchConverter(newHSL));
        setRGB(newRgb_3);
        setHEX(formatHex(newRgb_3));
        clearErrors();
      } else {
        setHueError(true);
      }
    };
    $[60] = hsl;
    $[61] = t39;
  } else {
    t39 = $[61];
  }
  let t40;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = e_4 => {
      const pastedData_0 = e_4.clipboardData.getData("text");
      const parsed_0 = parse(pastedData_0);
      if (parsed_0 && parsed_0.mode === "hsl") {
        e_4.preventDefault();
        setHSL(parsed_0);
        const newRgb_4 = rgbConverter(parsed_0);
        setOklch(oklchConverter(parsed_0));
        setRGB(newRgb_4);
        setHEX(formatHex(newRgb_4));
        clearErrors();
      }
    };
    $[62] = t40;
  } else {
    t40 = $[62];
  }
  let t41;
  if ($[63] !== t38 || $[64] !== t39) {
    t41 = <Input id="hsl-h" type="number" step={1} min={0} max={360} value={t38} onChange={t39} onPaste={t40} />;
    $[63] = t38;
    $[64] = t39;
    $[65] = t41;
  } else {
    t41 = $[65];
  }
  const t42 = hueError ? "Must be between 0 and 360" : null;
  let t43;
  if ($[66] !== t42) {
    t43 = <div className="text-destructive h-5 text-sm">{t42}</div>;
    $[66] = t42;
    $[67] = t43;
  } else {
    t43 = $[67];
  }
  let t44;
  if ($[68] !== t41 || $[69] !== t43) {
    t44 = <div className="flex flex-1 flex-col gap-2">{t37}{t41}{t43}</div>;
    $[68] = t41;
    $[69] = t43;
    $[70] = t44;
  } else {
    t44 = $[70];
  }
  let t45;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <Label htmlFor="hsl-s">Saturation</Label>;
    $[71] = t45;
  } else {
    t45 = $[71];
  }
  const t46 = isNaN(hsl.s) ? "" : hsl.s;
  let t47;
  if ($[72] !== hsl) {
    t47 = e_5 => {
      const newHSL_0 = {
        ...hsl,
        s: parseFloat(e_5.target.value)
      };
      setHSL(newHSL_0);
      if (validateHSL(newHSL_0)) {
        const newRgb_5 = rgbConverter(newHSL_0);
        setOklch(oklchConverter(newHSL_0));
        setRGB(newRgb_5);
        setHEX(formatHex(newRgb_5));
        clearErrors();
      } else {
        setSaturationError(true);
      }
    };
    $[72] = hsl;
    $[73] = t47;
  } else {
    t47 = $[73];
  }
  let t48;
  if ($[74] !== t46 || $[75] !== t47) {
    t48 = <Input id="hsl-s" type="number" value={t46} step={1} min={0} max={100} onChange={t47} />;
    $[74] = t46;
    $[75] = t47;
    $[76] = t48;
  } else {
    t48 = $[76];
  }
  const t49 = saturationError ? "Must be between 0 and 100" : null;
  let t50;
  if ($[77] !== t49) {
    t50 = <div className="text-destructive h-5 text-sm">{t49}</div>;
    $[77] = t49;
    $[78] = t50;
  } else {
    t50 = $[78];
  }
  let t51;
  if ($[79] !== t48 || $[80] !== t50) {
    t51 = <div className="flex flex-1 flex-col gap-2">{t45}{t48}{t50}</div>;
    $[79] = t48;
    $[80] = t50;
    $[81] = t51;
  } else {
    t51 = $[81];
  }
  let t52;
  if ($[82] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <Label htmlFor="hsl-l">Lightness</Label>;
    $[82] = t52;
  } else {
    t52 = $[82];
  }
  const t53 = isNaN(hsl.l) ? "" : hsl.l;
  let t54;
  if ($[83] !== hsl) {
    t54 = e_6 => {
      const newHSL_1 = {
        ...hsl,
        l: parseFloat(e_6.target.value)
      };
      setHSL(newHSL_1);
      if (validateHSL(newHSL_1)) {
        const newRgb_6 = rgbConverter(newHSL_1);
        setOklch(oklchConverter(newHSL_1));
        setRGB(newRgb_6);
        setHEX(formatHex(newRgb_6));
        clearErrors();
      } else {
        setLightnessError(true);
      }
    };
    $[83] = hsl;
    $[84] = t54;
  } else {
    t54 = $[84];
  }
  let t55;
  if ($[85] !== t53 || $[86] !== t54) {
    t55 = <Input id="hsl-l" type="number" value={t53} step={1} min={0} max={100} onChange={t54} />;
    $[85] = t53;
    $[86] = t54;
    $[87] = t55;
  } else {
    t55 = $[87];
  }
  const t56 = lightnessError ? "Must be between 0 and 100" : null;
  let t57;
  if ($[88] !== t56) {
    t57 = <div className="text-destructive h-5 text-sm">{t56}</div>;
    $[88] = t56;
    $[89] = t57;
  } else {
    t57 = $[89];
  }
  let t58;
  if ($[90] !== t55 || $[91] !== t57) {
    t58 = <div className="flex flex-1 flex-col gap-2">{t52}{t55}{t57}</div>;
    $[90] = t55;
    $[91] = t57;
    $[92] = t58;
  } else {
    t58 = $[92];
  }
  let t59;
  if ($[93] !== t44 || $[94] !== t51 || $[95] !== t58) {
    t59 = <div>{t36}<div className="flex flex-col gap-3 md:flex-row">{t44}{t51}{t58}</div></div>;
    $[93] = t44;
    $[94] = t51;
    $[95] = t58;
    $[96] = t59;
  } else {
    t59 = $[96];
  }
  let t60;
  if ($[97] === Symbol.for("react.memo_cache_sentinel")) {
    t60 = <h2 className="leading-loose">RGB</h2>;
    $[97] = t60;
  } else {
    t60 = $[97];
  }
  let t61;
  if ($[98] === Symbol.for("react.memo_cache_sentinel")) {
    t61 = <Label htmlFor="rgb-r">Red</Label>;
    $[98] = t61;
  } else {
    t61 = $[98];
  }
  const t62 = isNaN(rgb.r) ? "" : rgb.r;
  let t63;
  if ($[99] !== rgb) {
    t63 = e_7 => {
      const newRGB = {
        ...rgb,
        r: parseInt(e_7.target.value)
      };
      setRGB(newRGB);
      if (validateRGB(newRGB)) {
        setOklch(oklchConverter(newRGB));
        setHSL(hslConverter(newRGB));
        setHEX(formatHex(newRGB));
        clearErrors();
      } else {
        setRedError(true);
      }
    };
    $[99] = rgb;
    $[100] = t63;
  } else {
    t63 = $[100];
  }
  let t64;
  if ($[101] === Symbol.for("react.memo_cache_sentinel")) {
    t64 = e_8 => {
      const pastedData_1 = e_8.clipboardData.getData("text");
      const parsed_1 = parse(pastedData_1);
      if (parsed_1 && parsed_1.mode === "rgb") {
        e_8.preventDefault();
        setRGB(parsed_1);
        setOklch(oklchConverter(parsed_1));
        setHSL(hslConverter(parsed_1));
        setHEX(formatHex(parsed_1));
        clearErrors();
      }
    };
    $[101] = t64;
  } else {
    t64 = $[101];
  }
  let t65;
  if ($[102] !== t62 || $[103] !== t63) {
    t65 = <Input id="rgb-r" type="number" value={t62} step={1} min={0} max={255} onChange={t63} onPaste={t64} />;
    $[102] = t62;
    $[103] = t63;
    $[104] = t65;
  } else {
    t65 = $[104];
  }
  const t66 = redError ? "Must be between 0 and 255" : null;
  let t67;
  if ($[105] !== t66) {
    t67 = <div className="text-destructive h-5 text-sm">{t66}</div>;
    $[105] = t66;
    $[106] = t67;
  } else {
    t67 = $[106];
  }
  let t68;
  if ($[107] !== t65 || $[108] !== t67) {
    t68 = <div className="flex flex-1 flex-col gap-2">{t61}{t65}{t67}</div>;
    $[107] = t65;
    $[108] = t67;
    $[109] = t68;
  } else {
    t68 = $[109];
  }
  let t69;
  if ($[110] === Symbol.for("react.memo_cache_sentinel")) {
    t69 = <Label htmlFor="rgb-g">Green</Label>;
    $[110] = t69;
  } else {
    t69 = $[110];
  }
  const t70 = isNaN(rgb.g) ? "" : rgb.g;
  let t71;
  if ($[111] !== rgb) {
    t71 = e_9 => {
      const newRGB_0 = {
        ...rgb,
        g: parseInt(e_9.target.value)
      };
      setRGB(newRGB_0);
      if (validateRGB(newRGB_0)) {
        setOklch(oklchConverter(newRGB_0));
        setHSL(hslConverter(newRGB_0));
        setHEX(formatHex(newRGB_0));
        clearErrors();
      } else {
        setGreenError(true);
      }
    };
    $[111] = rgb;
    $[112] = t71;
  } else {
    t71 = $[112];
  }
  let t72;
  if ($[113] !== t70 || $[114] !== t71) {
    t72 = <Input id="rgb-g" type="number" value={t70} step={1} min={0} max={255} onChange={t71} />;
    $[113] = t70;
    $[114] = t71;
    $[115] = t72;
  } else {
    t72 = $[115];
  }
  const t73 = greenError ? "Must be between 0 and 255" : null;
  let t74;
  if ($[116] !== t73) {
    t74 = <div className="text-destructive h-5 text-sm">{t73}</div>;
    $[116] = t73;
    $[117] = t74;
  } else {
    t74 = $[117];
  }
  let t75;
  if ($[118] !== t72 || $[119] !== t74) {
    t75 = <div className="flex flex-1 flex-col gap-2">{t69}{t72}{t74}</div>;
    $[118] = t72;
    $[119] = t74;
    $[120] = t75;
  } else {
    t75 = $[120];
  }
  let t76;
  if ($[121] === Symbol.for("react.memo_cache_sentinel")) {
    t76 = <Label htmlFor="rgb-b">Blue</Label>;
    $[121] = t76;
  } else {
    t76 = $[121];
  }
  const t77 = isNaN(rgb.b) ? "" : rgb.b;
  let t78;
  if ($[122] !== rgb) {
    t78 = e_10 => {
      const newRGB_1 = {
        ...rgb,
        b: parseInt(e_10.target.value)
      };
      setRGB(newRGB_1);
      if (validateRGB(newRGB_1)) {
        setOklch(oklchConverter(newRGB_1));
        setHSL(hslConverter(newRGB_1));
        setHEX(formatHex(newRGB_1));
        clearErrors();
      } else {
        setBlueError(true);
      }
    };
    $[122] = rgb;
    $[123] = t78;
  } else {
    t78 = $[123];
  }
  let t79;
  if ($[124] !== t77 || $[125] !== t78) {
    t79 = <Input id="rgb-b" type="number" value={t77} step={1} min={0} max={255} onChange={t78} />;
    $[124] = t77;
    $[125] = t78;
    $[126] = t79;
  } else {
    t79 = $[126];
  }
  const t80 = blueError ? "Must be between 0 and 255" : null;
  let t81;
  if ($[127] !== t80) {
    t81 = <div className="text-destructive h-5 text-sm">{t80}</div>;
    $[127] = t80;
    $[128] = t81;
  } else {
    t81 = $[128];
  }
  let t82;
  if ($[129] !== t79 || $[130] !== t81) {
    t82 = <div className="flex flex-1 flex-col gap-2">{t76}{t79}{t81}</div>;
    $[129] = t79;
    $[130] = t81;
    $[131] = t82;
  } else {
    t82 = $[131];
  }
  let t83;
  if ($[132] !== t68 || $[133] !== t75 || $[134] !== t82) {
    t83 = <div>{t60}<div className="flex flex-col gap-3 md:flex-row">{t68}{t75}{t82}</div></div>;
    $[132] = t68;
    $[133] = t75;
    $[134] = t82;
    $[135] = t83;
  } else {
    t83 = $[135];
  }
  let t84;
  if ($[136] === Symbol.for("react.memo_cache_sentinel")) {
    t84 = <Label htmlFor="hex">Hex</Label>;
    $[136] = t84;
  } else {
    t84 = $[136];
  }
  let t85;
  if ($[137] === Symbol.for("react.memo_cache_sentinel")) {
    t85 = e_11 => {
      const newHex = e_11.target.value;
      setHEX(newHex);
      if (validateHEX(newHex)) {
        setOklch(oklchConverter(newHex) as Oklch);
        setRGB(rgbConverter(newHex) as Rgb);
        setHSL(hslConverter(newHex) as Hsl);
        clearErrors();
      } else {
        setHexError(true);
      }
    };
    $[137] = t85;
  } else {
    t85 = $[137];
  }
  let t86;
  if ($[138] !== hex) {
    t86 = <Input id="hex" type="text" value={hex} onChange={t85} />;
    $[138] = hex;
    $[139] = t86;
  } else {
    t86 = $[139];
  }
  const t87 = hexError ? "Invalid hex code" : null;
  let t88;
  if ($[140] !== t87) {
    t88 = <div className="text-destructive h-5 text-sm">{t87}</div>;
    $[140] = t87;
    $[141] = t88;
  } else {
    t88 = $[141];
  }
  let t89;
  if ($[142] !== t86 || $[143] !== t88) {
    t89 = <div className="flex flex-col gap-2">{t84}{t86}{t88}</div>;
    $[142] = t86;
    $[143] = t88;
    $[144] = t89;
  } else {
    t89 = $[144];
  }
  let t90;
  if ($[145] !== t11 || $[146] !== t35 || $[147] !== t59 || $[148] !== t83 || $[149] !== t89) {
    t90 = <CardContent className="flex flex-col gap-8">{t11}{t35}{t59}{t83}{t89}</CardContent>;
    $[145] = t11;
    $[146] = t35;
    $[147] = t59;
    $[148] = t83;
    $[149] = t89;
    $[150] = t90;
  } else {
    t90 = $[150];
  }
  let t91;
  if ($[151] !== t7 || $[152] !== t90) {
    t91 = <Card className="mx-auto w-full">{t7}{t90}</Card>;
    $[151] = t7;
    $[152] = t90;
    $[153] = t91;
  } else {
    t91 = $[153];
  }
  return t91;
}
export { ColourConverter };